<div class="tabdashboard chart-page card card-body">
  <div class="tabdashboard-inner container-fluid cardone">
    <!-- <button class="tablinks active" id="defaultOpen" onclick="openTab(event, 'divExcursion')">Excursion</button> -->
    <!-- <button class="tablinks" onclick="openTab(event, 'divTransfers')">Transfers</button>
    <button class="tablinks" onclick="openTab(event, 'divAirportServices')">Airport Services</button> -->
  </div>
</div>

<div id="divExcursion" style="display: block;" class="tabcontent-dashboard">
  <main class="main users chart-page card card-body" id="skip-target">


    <div  class="container-fluid cardone">
      <div class="row">
        
        <h2 class="col-6 main-title">Dashboard</h2>
        <h2 class="col-6 main-title" data-toggle="collapse" (click)="autofocus()" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" style="text-align: right;">Search View</h2>
      </div>

      <form class="collapse" id="collapseExample" [formGroup]="registerForm" (ngSubmit)="registerFormSubmit()">
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name">Requested Date From:</label>
            </div>
            <div class="col-12 ">
              
              <p-calendar [readonlyInput]="true" #theCalendarreq  [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" dateFormat="dd-m-yy" formControlName="request_date_from" ></p-calendar>
              <!-- <input type="text" formControlName="name" id="name" class="form-input" placeholder="Name" required > -->
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name">Requested Date To:</label>
            </div>
            <div class="col-12 ">
              <p-calendar [readonlyInput]="true"  [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" dateFormat="dd-m-yy" formControlName="request_date_to" ></p-calendar>
              <!-- <input type="text" formControlName="request_date_to" id="name" class="form-input" placeholder="Name" required > -->
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name">Guest Arrival / Excursion Date From</label>
            </div>
            <div class="col-12 ">
              <p-calendar [readonlyInput]="true" [style]="{'width':'100%'}"   [inputStyle]="{'width':'100%'}" dateFormat="dd-m-yy" formControlName="transfer_date_from" ></p-calendar>
              <!-- <input type="text" formControlName="transfer_date_from" id="name" class="form-input" placeholder="Name" required > -->
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name">Guest Arrival / Excursion Date To</label>
            </div>
            <div class="col-12 ">
              <p-calendar [readonlyInput]="true" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" dateFormat="dd-m-yy"  formControlName="transfer_date_to" ></p-calendar>
              <!-- <input type="text" formControlName="transfer_date_to" id="name" class="form-input" placeholder="Name" required > -->
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name">Priority</label>
            </div>
            <div class="col-12 ">
              <ng-select 
              [items]="prioritylist"
              bindLabel="priority_name"
              bindValue="priority_id"
              formControlName = "priority"                                
              >
    </ng-select>
              <!-- <ng-select formControlName="priority">
                <ng-option *ngFor="let priority of prioritylist" [value]="priority.priority_id">{{priority.priority_name}}</ng-option>
             </ng-select> -->
              <!-- <input type="text" formControlName="priority" id="name"  placeholder="Name" required > -->
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name">Criticality</label>
            </div>
            <div class="col-12 ">
              <!-- <p-dropdown  [options]="critical_list" [style]="{'width':'100%'}"  formControlName="criticality" optionLabel="value" optionValue="id" [filter]="true" filterBy="partyname" [showClear]="true" placeholder="Select a Supplier">
                  
              </p-dropdown> -->
              <ng-select formControlName="criticality">
                
                <ng-option *ngFor="let car of critical_list" [value]="car.id">{{car.value}}</ng-option>
             </ng-select>
              <!-- <input type="text" formControlName="criticality" id="name"  placeholder="Name" required > -->
            </div>
          </div>
          <div class="col-lg-1 col-md-1 col-sm-6 col-xs-12 ">
            <div class="col-12 ">
              <label class="form-label" for="name"><br></label>
            </div>
            <div class="col-12 ">
              <button type="submit" class="primary-default-btn">Search</button>
              <!-- <input type="button" formControlName="name" id="name" class="form-btn" placeholder="Name" required > -->
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
            <div class="col-6 ">
              <label class="form-label" for="name"><br></label>
            </div>
            <div class="col-6 ">
              <button type="button" (click)="reset()" style="background-color: #9e9e9e" class="primary-default-btn">Reset</button>
            </div>
          </div>
        </div>
        
        <div class="row">
        <br>
        </div>
        </form>
      <div class="row stat-cards">
        <div class="col-md-6 col-xl-3">
          <article class="stat-cards-item total">
            <div class="stat-cards-icon primary">
              <!-- <i data-feather="bar-chart-2" aria-hidden="true"></i> -->
              
              <i class="pi pi-book" style="color:#1c84c6;font-size: 2rem"></i>
              
              
            </div>
            <div (click)="clicktoload(this.registerForm.value,'')" class="stat-cards-info ">
              <p class="stat-cards-info__num">{{this.dashboar_data.total}}</p>
              <p class="stat-cards-info__title">Total Work Count</p>
              <p class="stat-cards-info__progress">
                <!-- <span class="stat-cards-info__profit success">
                  <i class="pi pi-book" style="font-size: 2rem"></i>
                </span> -->
               <!-- Total Work Count -->
              </p>
            </div>
          </article>
        </div>
        <div (click)="clicktoload(this.registerForm.value,1)" class="col-md-6 col-xl-3">
          <article class="stat-cards-item pending">
            <div class="stat-cards-icon warning">
              <i class="pi pi-clock" style="color:#23c6c8;font-size: 2rem"></i>
              
              
            </div>
            <div class="stat-cards-info">
              <p class="stat-cards-info__num">{{this.dashboar_data.pending_count}}</p>
              <p class="stat-cards-info__title">Pending</p>
              <p class="stat-cards-info__progress">
                <!-- <span class="stat-cards-info__profit success">
                  <i data-feather="trending-up" aria-hidden="true"></i>0.24%
                </span> -->
               <!-- Pending -->
              </p>
            </div>
          </article>
        </div>
        <div (click)="clicktoload(this.registerForm.value,2)" class="col-md-6 col-xl-3">
          <article class="stat-cards-item assigned">
            <div class="stat-cards-icon purple">
              <i class="pi pi-users" style="color:#23c6c8;font-size: 2rem"></i>
            </div>
            <div class="stat-cards-info">
              <p class="stat-cards-info__num">{{this.dashboar_data.assigned_count}}</p>
              <p class="stat-cards-info__title">Assigned</p>
              <p class="stat-cards-info__progress">
                <!-- <span class="stat-cards-info__profit danger">
                  <i data-feather="trending-down" aria-hidden="true"></i>
                </span> -->
                <!-- Last month -->
              </p>
            </div>
          </article>
        </div>
        <div (click)="clicktoload(this.registerForm.value,3)" class="col-md-6 col-xl-3">
          <article class="stat-cards-item confirmed">
            <div class="stat-cards-icon success">
              <i class="pi pi-thumbs-up" style="color:#1ab394;font-size: 2rem"></i>
              
              
            </div>
            <div class="stat-cards-info">
              <p class="stat-cards-info__num">{{this.dashboar_data.completed_count}}</p>
              <p class="stat-cards-info__title">Confirmed</p>
              <p class="stat-cards-info__progress">
                <!-- <span class="stat-cards-info__profit warning">
                  <i data-feather="trending-up" aria-hidden="true"></i>0.00%
                </span> -->
                <!-- Last month -->
              </p>
            </div>
          </article>
        </div>
        <div (click)="clicktoload(this.registerForm.value,6)" class="col-md-6 col-xl-3">
          <article class="stat-cards-item amendments">
            <div class="stat-cards-icon success">
              <i class="pi pi-info" style="color:#f8ac59 ;font-size: 2rem"></i>
              
              
            </div>
            <div class="stat-cards-info">
              <p class="stat-cards-info__num">{{this.dashboar_data.amend_count}}</p>
              <p class="stat-cards-info__title">Amendments</p>
              <p class="stat-cards-info__progress">
                <span class="stat-cards-info__profit warning">
                  <!-- <i data-feather="trending-up" aria-hidden="true"></i>0.00% -->
                </span>
                <!-- Last month -->
              </p>
            </div>
          </article>
        </div>
        <div (click)="clicktoload(this.registerForm.value,5)" class="col-md-6 col-xl-3">
          <article class="stat-cards-item rejected">
            <div class="stat-cards-icon success">
              <i class="pi pi-thumbs-down" style="color:#ed5565  ;font-size: 2rem"></i>
              
              
            </div>
            <div class="stat-cards-info">
              <p class="stat-cards-info__num">{{this.dashboar_data.rejected_count}}</p>
              <p class="stat-cards-info__title">Rejected</p>
              <p class="stat-cards-info__progress">
                <!-- <span class="stat-cards-info__profit warning">
                  <i data-feather="trending-up" aria-hidden="true"></i>0.00%
                </span> -->
                <!-- Last month -->
              </p>
            </div>
          </article>
        </div>
        <div (click)="clicktoload(this.registerForm.value,4)" class="col-md-6 col-xl-3">
          <article class="stat-cards-item cancelled">
            <div class="stat-cards-icon success">
              <i class="pi pi-times" style="color:#a71b29  ;font-size: 2rem"></i>
            </div>
            <div class="stat-cards-info">
              <p class="stat-cards-info__num">{{this.dashboar_data.cancelled_count}}</p>
              <p class="stat-cards-info__title">Cancelled</p>
              <p class="stat-cards-info__progress">
                <!-- <span class="stat-cards-info__profit warning">
                  <i data-feather="trending-up" aria-hidden="true"></i>
                </span> -->
                <!-- Last month -->
              </p>
            </div>
          </article>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="col-lg-12 chart">
           
            <canvas  id="pieChart" width="100%" height="100%" >{{ chart }}</canvas>
           
          </div>
          <div class="col-lg-12 chart">
            <p class="stat-cards-info__title title">Team Member</p>
            <div class="users-table table-wrapper">
              <table class="posts-table">
                <thead>
                  <tr class="users-table-info">
                    <th>
                      Member Name
                    </th>
                    <th>Total</th>
                    <th>Pending</th>
                    <th>Assigned</th>
                    <th>Completed</th>
                    <th>Rejected</th>
                    <th>Cancelled</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="this.team_member_count!=undefined ">
                    <td>
                      {{this.team_member_count['UserName']}}
                    </td>
                    <td>
                      <span class="badge-disabled">{{this.team_member_count['s_total_count']}} </span>
                    </td>
                    <td>
                      <span class="badge-pending">{{this.team_member_count['pending_count']}}</span>
                    </td>
                    <td>
                      <span class="badge-active">{{this.team_member_count['assigned_count']}}</span>
                      <!-- <div class="pages-table-img">
                        <picture><source srcset="https://therichpost.com/wp-content/uploads/2021/03/avatar7.png" type="image/webp"><img src="https://therichpost.com/wp-content/uploads/2021/03/avatar7.png" alt="User Name"></picture>
                        Jassa
                      </div> -->
                    </td>
                    <td><span class="badge-success">{{this.team_member_count['completed_count']}}</span></td>
                    <td><span class="badge-trashed">{{this.team_member_count['rejected_count']}}</span></td>
                    <td>
                      <span style="background-color: #a71b29;" class="badge-trashed">{{this.team_member_count['cancelled_count']}}</span>
                    </td>
                  </tr>
                  
                
                </tbody>
              </table>
            </div>
  
          </div>
          
        </div>
        <div class="col-lg-6">
          <div class="col-lg-12 chart">
            <!-- <canvas id="lineChart" aria-label="Site statistics" role="img"></canvas> -->
            <canvas  id="pieChart_supplier" width="100%" height="100%" >{{ supplier_chart }}</canvas>
          </div>
          <div class="col-lg-12 chart">
            <p class="stat-cards-info__title title">Service Provider</p>
            <div class="users-table table-wrapper">
              <p-scrollPanel [style]="{width: '100%', height: '60vh'}">
              <table class="posts-table">
                <thead>
                  <tr class="users-table-info">
                    <th>
                      Name
                    </th>
                    <th>Total</th>
                   
                    <th>Assigned</th>
                    <th>Completed</th>
                    <th>Rejected</th>
                    <th>Cancelled</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let sup of supplier_count; index as i">
                    <td>
                      {{sup['partyname']}}
                    </td>
                    <td>
                      <span class="badge-disabled">{{sup['assigned_count']+sup['completed_count']+sup['rejected_count']+sup['cancelled_count']}} </span>
                    </td>
                   
                    <td>
                      <span class="badge-active">{{sup['assigned_count']}}</span>
                      <!-- <div class="pages-table-img">
                        <picture><source srcset="https://therichpost.com/wp-content/uploads/2021/03/avatar7.png" type="image/webp"><img src="https://therichpost.com/wp-content/uploads/2021/03/avatar7.png" alt="User Name"></picture>
                        Jassa
                      </div> -->
                    </td>
                    <td><span class="badge-success">{{sup['completed_count']}}</span></td>
                    <td><span class="badge-trashed">{{sup['rejected_count']}}</span></td>
                    <td>
                      <span style="background-color: #a71b29;"  class="badge-trashed">{{sup['cancelled_count']}}</span>
                    </td>
                  </tr>
                  
                
                </tbody>
              </table>
            </p-scrollPanel>
            </div>
  
          </div>
         
        </div>
        <!-- <div class="col-lg-3">
          <article class="customers-wrapper">
            <canvas id="customersChart" aria-label="Customers statistics" role="img"></canvas>
            
          </article>
          <article class="white-block">
            <div class="top-cat-title">
              <h3>Top categories</h3>
              <p>28 Categories, 1400 Posts</p>
            </div>
            <ul class="top-cat-list">
              <li>
                <a href="##">
                  <div class="top-cat-list__title">
                    Lifestyle <span>8.2k</span>
                  </div>
                  <div class="top-cat-list__subtitle">
                    Dailiy lifestyle articles <span class="purple">+472</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="##">
                  <div class="top-cat-list__title">
                    Tutorials <span>8.2k</span>
                  </div>
                  <div class="top-cat-list__subtitle">
                    Coding tutorials <span class="blue">+472</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="##">
                  <div class="top-cat-list__title">
                    Technology <span>8.2k</span>
                  </div>
                  <div class="top-cat-list__subtitle">
                    Dailiy technology articles <span class="danger">+472</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="##">
                  <div class="top-cat-list__title">
                    UX design <span>8.2k</span>
                  </div>
                  <div class="top-cat-list__subtitle">
                    UX design tips <span class="success">+472</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="##">
                  <div class="top-cat-list__title">
                    Interaction tips <span>8.2k</span>
                  </div>
                  <div class="top-cat-list__subtitle">
                    Interaction articles <span class="warning">+472</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="##">
                  <div class="top-cat-list__title">
                    App development <span>8.2k</span>
                  </div>
                  <div class="top-cat-list__subtitle">
                    Mobile development articles <span class="warning">+472</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="##">
                  <div class="top-cat-list__title">
                    Nature <span>8.2k</span>
                  </div>
                  <div class="top-cat-list__subtitle">
                    Wildlife animal articles <span class="warning">+472</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="##">
                  <div class="top-cat-list__title">
                    Geography <span>8.2k</span>
                  </div>
                  <div class="top-cat-list__subtitle">
                    Geography articles <span class="primary">+472</span>
                  </div>
                </a>
              </li>
            </ul>
          </article>
        </div> -->
      </div>
    </div>
  </main>
</div>

<div id="divTransfers" class="tabcontent-dashboard">
  <h1>Transfers</h1>
</div>

<div id="divAirportServices" class="tabcontent-dashboard">
  <h1>Airport Services</h1>
</div>